document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-type="add-to-cart-form"]');
  if (!form) return;
  if (form.dataset.sampleAdded) return;

  var addonWrapper = document.querySelector('.shade-sample-addon');
  var checkbox = addonWrapper && addonWrapper.querySelector('.shade-sample-addon__checkbox');
  if (!checkbox || !checkbox.checked) return;

  var sampleVariantId = addonWrapper.dataset.sampleVariantId;
  if (!sampleVariantId) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  var sampleData = new FormData();
  sampleData.append('id', sampleVariantId);
  sampleData.append('quantity', 1);

  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: sampleData,
  })
    .then(function (response) { return response.json(); })
    .then(function () {
      resubmitNaturally();
    })
    .catch(function (error) {
      console.error('Error adding shade sample to cart:', error);
      resubmitNaturally();
    });

  function resubmitNaturally() {
    form.dataset.sampleAdded = 'true';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
}, true);